import { Card, Stack, Typography } from '@mui/material';

import { Icon } from '@/components/atoms/Icon/Icon';
import type { Icons } from '@/components/atoms/Icon/icons';
import { BottomSheetDialog } from '@/pwa/atoms/BottomSheetDialog/BottomSheetDialog';

/** Photos are the camera or the library; files are the document picker. */
export type UploadSource = 'photos' | 'files';

export interface UploadSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onChoose: (source: UploadSource) => void;
}

const TITLE = 'Upload';

const OPTIONS: { source: UploadSource; label: string; icon: Icons }[] = [
  { source: 'photos', label: 'Photos', icon: 'camera' },
  { source: 'files', label: 'Files', icon: 'file-lines' },
];

/** UploadSheet asks where an attachment is coming from. */
export const UploadSheet = ({
  isOpen,
  onClose,
  onChoose,
}: UploadSheetProps) => (
  <BottomSheetDialog isOpen={isOpen} onClose={onClose} title={TITLE}>
    <Stack spacing={1} sx={{ pb: 2 }}>
      {OPTIONS.map(({ source, label, icon }) => (
        <Card
          key={source}
          component='button'
          type='button'
          variant='option'
          onClick={() => onChoose(source)}
          sx={{ width: '100%', textAlign: 'left' }}
        >
          <Stack direction='row' spacing={1.5} sx={{ alignItems: 'center' }}>
            <Icon icon={icon} fontSize={18} />
            <Typography variant='h6'>{label}</Typography>
          </Stack>
        </Card>
      ))}
    </Stack>
  </BottomSheetDialog>
);

UploadSheet.displayName = 'UploadSheet';
export default UploadSheet;
